import { HTMLAttributes } from 'react'

import { Colors, sidebarStatusColors } from 'src/resources/colors'

export const Logo = ({
  style = {},
  fill = Colors.brandPrimary,
  fillSecondary = Colors.textLogo,
  height = '36px',
  viewBox = '0 0 282.24 65.31'
}: any) => {
  return (
    <svg style={style} height={height} xmlns='http://www.w3.org/2000/svg' viewBox={viewBox}>
      <path
        fill={fill}
        fillRule='nonzero'
        d='M16.08 35.71a4.21 4.21 0 0 1-3 1.22h-10A3.14 3.14 0 0 1 0 33.8V3.13A3.08 3.08 0 0 1 .92.92 3.08 3.08 0 0 1 3.13 0h18.31a3.12 3.12 0 0 1 3.13 3.13v22.35a4.17 4.17 0 0 1-1.22 2.95l-3.64 3.64ZM29.42 16.08a4.2 4.2 0 0 1-1.22-2.95v-10A3.12 3.12 0 0 1 31.33 0H62a3.14 3.14 0 0 1 3.13 3.13v18.31A3.12 3.12 0 0 1 62 24.57H39.64a4.2 4.2 0 0 1-3-1.22l-3.63-3.64ZM49.05 29.6a4.19 4.19 0 0 1 3-1.22H62a3.14 3.14 0 0 1 3.13 3.13v30.67a3.08 3.08 0 0 1-.92 2.21 3.11 3.11 0 0 1-2.21.92H43.68a3.14 3.14 0 0 1-3.13-3.13V39.83a4.14 4.14 0 0 1 1.23-2.95l3.64-3.64ZM35.71 49.23a4.21 4.21 0 0 1 1.22 3v10a3.14 3.14 0 0 1-3.13 3.13H3.13A3.14 3.14 0 0 1 0 62.18V43.87a3.12 3.12 0 0 1 3.13-3.13h22.35A4.17 4.17 0 0 1 28.43 42l3.64 3.64Z'
      />
      <path
        fill={fillSecondary}
        fillRule='nonzero'
        d='M168.45 49.16c-.42.31-.78.55-1.06.74s-.52.31-.71.41a1.57 1.57 0 0 1-.52.17 4.58 4.58 0 0 1-.59 0 1.73 1.73 0 0 1-1.74-1.13 13 13 0 0 1-.47-4.27v-9.63a22.24 22.24 0 0 0-.27-4 8.06 8.06 0 0 0-1-2.58c-1.57-2.51-4.68-3.78-9.24-3.78a16.2 16.2 0 0 0-8 1.68 5.2 5.2 0 0 0-2.94 4.65 3.46 3.46 0 0 0 .92 2.5 3.14 3.14 0 0 0 2.35 1 3.45 3.45 0 0 0 2.52-.92 3.11 3.11 0 0 0 1-2.35 2.71 2.71 0 0 0-.78-2 6.46 6.46 0 0 1-.61-.65.33.33 0 0 1-.09-.22.89.89 0 0 1 .38-.66 3.8 3.8 0 0 1 1-.58 6 6 0 0 1 1.41-.41 8.72 8.72 0 0 1 1.62-.15c2.69 0 4.51.81 5.4 2.4a6.14 6.14 0 0 1 .47 1.06 6.93 6.93 0 0 1 .29 1.26 17.37 17.37 0 0 1 .18 1.83c0 .77.08 1.66.12 2.66l-5.52 1-2.24.35c-1.13.2-2.06.39-2.83.56a14.75 14.75 0 0 0-2.07.62 11.5 11.5 0 0 0-1.57.77 13 13 0 0 0-1.33 1 7 7 0 0 0-2.13 5.44 7.46 7.46 0 0 0 8.06 8.05 10.47 10.47 0 0 0 5-1.19 17.45 17.45 0 0 0 4.54-3.96 13.74 13.74 0 0 0 .52 1.87 5.75 5.75 0 0 0 .65 1.22 4.24 4.24 0 0 0 1.52 1.3 4 4 0 0 0 1.87.48 6.42 6.42 0 0 0 3.11-.83 17.16 17.16 0 0 0 3.46-2.72l-.72-1ZM158.1 38v4.57a9.3 9.3 0 0 1-.94 4.64 6.33 6.33 0 0 1-2.53 2.44 7.1 7.1 0 0 1-3.46.91 5.14 5.14 0 0 1-3.85-1.47 5.4 5.4 0 0 1-1.44-3.93 5.14 5.14 0 0 1 3.53-5.16 19.89 19.89 0 0 1 3.23-.91c1.36-.34 3.21-.68 5.46-1.09ZM188.78 49.57a25.4 25.4 0 0 1-2.45.83 7.16 7.16 0 0 1-1.73.23 4.08 4.08 0 0 1-3.3-1.31 6 6 0 0 1-1.1-3.93V28.74h8.2V26.8h-8.2v-11h-1.27l-3.84 3.84v7.1h-6.69v1.94h6.66v18.73a7 7 0 0 0 1.48 4.85 5.78 5.78 0 0 0 4.46 1.62 12.32 12.32 0 0 0 3.9-.65 24.81 24.81 0 0 0 4.53-2.23l-.66-1.44ZM223.7 22.2a3.47 3.47 0 0 0 2.55-1 3.52 3.52 0 0 0-5-5 3.28 3.28 0 0 0-1 2.43 3.51 3.51 0 0 0 1 2.53 3.29 3.29 0 0 0 2.45 1.04ZM280 46.62a25.34 25.34 0 0 1-2.3 2.15 10.42 10.42 0 0 1-2.12 1.35 9 9 0 0 1-2.2.71 15.7 15.7 0 0 1-2.62.2c-3.32 0-5.83-1.12-7.47-3.33a9.39 9.39 0 0 1-1.5-3.37 24 24 0 0 1-.44-5.16h20.93a28.3 28.3 0 0 0-.53-4.93 11.71 11.71 0 0 0-1.3-3.46 10.36 10.36 0 0 0-4.49-4.19 14.93 14.93 0 0 0-6.73-1.48 15.65 15.65 0 0 0-5.73 1 12.18 12.18 0 0 0-4.36 2.89 12.61 12.61 0 0 0-2.74 4.49 17 17 0 0 0-1 5.9 17.48 17.48 0 0 0 1 6 13.28 13.28 0 0 0 2.74 4.58 12.1 12.1 0 0 0 4.32 2.92 14.88 14.88 0 0 0 5.67 1 17.19 17.19 0 0 0 3.48-.34 12.15 12.15 0 0 0 3-1 15.21 15.21 0 0 0 2.84-1.86 21.5 21.5 0 0 0 2.8-2.78L280 46.64Zm-11-19.69c2.45 0 4.27.79 5.4 2.36s1.85 4.25 2.12 8h-15.15c.28-3.72 1-6.4 2.18-8a6.38 6.38 0 0 1 5.45-2.36ZM132.35 50.85a2.13 2.13 0 0 1-1.16-.87 4 4 0 0 1-.5-1.67 26.92 26.92 0 0 1-.12-2.88v-34l-10.29 2.46v1.91a11.34 11.34 0 0 1 2.52.32 2.91 2.91 0 0 1 1.55.9 3.74 3.74 0 0 1 .77 1.81 18.85 18.85 0 0 1 .2 3v23.6c0 1.16 0 2.12-.09 2.85a3.64 3.64 0 0 1-.49 1.7 2.31 2.31 0 0 1-1.2.87 17.12 17.12 0 0 1-2.15.5l-1.43.12v1.82h16v-1.82l-1.44-.12a17.12 17.12 0 0 1-2.17-.5ZM229.06 50.85a2.13 2.13 0 0 1-1.16-.85 4 4 0 0 1-.5-1.67 26.92 26.92 0 0 1-.12-2.88V24.34L217 26.8v1.92a11.34 11.34 0 0 1 2.52.32 2.91 2.91 0 0 1 1.55.9 3.64 3.64 0 0 1 .76 1.81 17.6 17.6 0 0 1 .21 3v10.68c0 1.16 0 2.12-.09 2.85a3.53 3.53 0 0 1-.5 1.7 2.29 2.29 0 0 1-1.19.87 17.12 17.12 0 0 1-2.15.5l-1.41.12v1.82h16v-1.82l-1.44-.12a17.12 17.12 0 0 1-2.2-.5ZM249.05 50.85a2.12 2.12 0 0 1-1.17-.87 4.12 4.12 0 0 1-.5-1.67c-.07-.7-.11-1.67-.11-2.88v-34L237 13.89v1.91a11.52 11.52 0 0 1 2.53.32 3 3 0 0 1 1.55.9 3.69 3.69 0 0 1 .76 1.81 17.6 17.6 0 0 1 .21 3v23.6c0 1.16 0 2.12-.09 2.85a3.64 3.64 0 0 1-.5 1.7 2.29 2.29 0 0 1-1.19.87 17.12 17.12 0 0 1-2.15.5l-1.42.12v1.82h16v-1.82l-1.43-.12a17.12 17.12 0 0 1-2.22-.5ZM212.64 13.76a7.78 7.78 0 0 0-4.64-1.27 8.81 8.81 0 0 0-6.77 2.73 10.58 10.58 0 0 0-2.51 7.42v2.44a17.07 17.07 0 0 0 .14 1.72h-5.36v1.94h5.36v16.68c0 1.17 0 2.13-.08 2.86a3.56 3.56 0 0 1-.5 1.69 2.24 2.24 0 0 1-1.2.88 16.9 16.9 0 0 1-2.14.5l-1.42.12v1.82h16.38v-1.82l-1.9-.12a16.9 16.9 0 0 1-2.14-.5 2.24 2.24 0 0 1-1.2-.88 3.6 3.6 0 0 1-.5-1.69c-.05-.72-.08-1.68-.08-2.86V28.74h7.37V26.8h-7.35a26.29 26.29 0 0 1-1.29-5.16 10.92 10.92 0 0 1 .09-4 3.86 3.86 0 0 1 2.1-2.8l.11-.05h.26a4.07 4.07 0 0 1 1.47-.26 3.86 3.86 0 0 1 1.5.29c.43.19.66.38.66.57s-.12.28-.35.51a3.1 3.1 0 0 0-.95 2.26 2.88 2.88 0 0 0 .89 2.2 3.2 3.2 0 0 0 2.26.83 3.26 3.26 0 0 0 2.56-1.19 4.11 4.11 0 0 0 1-2.84 4 4 0 0 0-1.77-3.4ZM86.9 13.91v1.93l2.15.24a4.73 4.73 0 0 1 3.22 1.23 3.66 3.66 0 0 1 .38.55 2.11 2.11 0 0 1 .21.76c0 .33.06.75.08 1.24s0 1.15 0 2v25.5c0 .51 0 .91-.08 1.24a2.43 2.43 0 0 1-.21.79 1.74 1.74 0 0 1-.38.52 4.68 4.68 0 0 1-3.22 1.23l-2.13.24v1.94h18.74v-1.97l-2.73-.24a4.5 4.5 0 0 1-3.23-1.23 1.64 1.64 0 0 1-.35-.52 3.88 3.88 0 0 1-.2-.79 9.3 9.3 0 0 1-.15-1.24V36.24h5.12a8.84 8.84 0 0 1 1.5.15A3.4 3.4 0 0 1 107 37a4.08 4.08 0 0 1 1 1.26 9.79 9.79 0 0 1 .8 2l.47 1.64h2.34V28h-2.33l-.38 1.6a16.39 16.39 0 0 1-.82 2.15 4.19 4.19 0 0 1-1 1.35 3.15 3.15 0 0 1-1.28.7 6.13 6.13 0 0 1-1.08.17H99v-17.6h6.45a27.58 27.58 0 0 1 4.71.33 5.81 5.81 0 0 1 2.84 1.2 4.7 4.7 0 0 1 1.42 2.44 19.26 19.26 0 0 1 .51 4h2.28V13.89Z'
      />
    </svg>
  )
}

export const LogoIcon = ({
  style = {},
  fill = Colors.brandPrimary,
  height = '12px',
  viewBox = '0 0 65.13 65.31'
}: any) => (
  <svg style={style} height={height} xmlns='http://www.w3.org/2000/svg' viewBox={viewBox}>
    <g>
      <g>
        <path
          fill={fill}
          d='M16.08 35.71a4.21 4.21 0 0 1-3 1.22h-10A3.14 3.14 0 0 1 0 33.8V3.13A3.08 3.08 0 0 1 .92.92 3.08 3.08 0 0 1 3.13 0h18.31a3.12 3.12 0 0 1 3.13 3.13v22.35a4.17 4.17 0 0 1-1.22 2.95l-3.64 3.64ZM29.42 16.08a4.2 4.2 0 0 1-1.22-2.95v-10A3.12 3.12 0 0 1 31.33 0H62a3.14 3.14 0 0 1 3.13 3.13v18.31A3.12 3.12 0 0 1 62 24.57H39.64a4.2 4.2 0 0 1-3-1.22l-3.63-3.64ZM49.05 29.6a4.19 4.19 0 0 1 3-1.22H62a3.14 3.14 0 0 1 3.13 3.13v30.67a3.08 3.08 0 0 1-.92 2.21 3.11 3.11 0 0 1-2.21.92H43.68a3.14 3.14 0 0 1-3.13-3.13V39.83a4.14 4.14 0 0 1 1.23-2.95l3.64-3.64ZM35.71 49.23a4.21 4.21 0 0 1 1.22 3v10a3.14 3.14 0 0 1-3.13 3.13H3.13A3.14 3.14 0 0 1 0 62.18V43.87a3.12 3.12 0 0 1 3.13-3.13h22.35A4.17 4.17 0 0 1 28.43 42l3.64 3.64Z'
        />
      </g>
    </g>
  </svg>
)

export const ClockLogo = (props: any) => {
  const { fill = Colors.textAccent } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'>
      <g fill='none' fillRule='evenodd'>
        <path
          fill={fill}
          fillRule='nonzero'
          d='M8,14 C4.6862915,14 2,11.3137085 2,8 C2,4.6862915 4.6862915,2 8,2 C11.3137085,2 14,4.6862915 14,8 C14,11.3137085 11.3137085,14 8,14 Z'
          opacity='.3'
        />
        <path
          fill={fill}
          fillRule='nonzero'
          d='M7.97534373,5 L8.0316708,5 C8.20292127,5 8.3463098,5.12976483 8.36334987,5.30016543 L8.66666667,8.33333333 L10.8320463,9.57069313 C10.9359047,9.63004073 11,9.74048853 11,9.86010753 L11,10 C11,10.1406109 10.8860123,10.2545986 10.7454014,10.2545986 C10.7227721,10.2545986 10.7002439,10.2515817 10.6784121,10.2456275 L7.59910747,9.4058172 C7.44485493,9.36374833 7.34219907,9.21807907 7.35446173,9.05866373 L7.6429922,5.30776783 C7.65635113,5.13410211 7.80116493,5 7.97534373,5 Z'
        />
      </g>
    </svg>
  )
}

export const CreditCardLogo = (props: any) => {
  const { fill = Colors.textAccent } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'>
      <g fill='none' fillRule='evenodd'>
        <rect
          width='13.3333333'
          height='9.33333333'
          x='1.33333333'
          y='3.33333333'
          fill={fill}
          fillRule='nonzero'
          opacity='.3'
          rx='1.33333333'
        />
        <path
          fill={fill}
          fillRule='nonzero'
          d='M1.33333333 5.33333333H14.66666663V7.33333333H1.33333333z'
        />
        <rect
          width='2.66666667'
          height='1.33333333'
          x='10.6666667'
          y='9.33333333'
          fill={fill}
          fillRule='nonzero'
          opacity='.3'
          rx='.66666667'
        />
      </g>
    </svg>
  )
}

export const ChatLogo = (props: any) => {
  const { fill = Colors.textAccent } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'>
      <g fill='none' fillRule='evenodd'>
        <path
          fill={fill}
          fillRule='nonzero'
          d='M3.33333333 10L2 14.3333333 6.33333333 13z'
          opacity='.3'
        />
        <path
          fill={fill}
          fillRule='nonzero'
          d='M9,14 C5.50219659,14 2.66666667,11.1644701 2.66666667,7.66666667 C2.66666667,4.16886325 5.50219659,1.33333333 9,1.33333333 C12.4978034,1.33333333 15.3333333,4.16886325 15.3333333,7.66666667 C15.3333333,11.1644701 12.4978034,14 9,14 Z M6,5.33333333 C5.63181017,5.33333333 5.33333333,5.63181017 5.33333333,6 C5.33333333,6.36818983 5.63181017,6.66666667 6,6.66666667 L12,6.66666667 C12.3681898,6.66666667 12.6666667,6.36818983 12.6666667,6 C12.6666667,5.63181017 12.3681898,5.33333333 12,5.33333333 L6,5.33333333 Z M6,8 C5.63181017,8 5.33333333,8.29847687 5.33333333,8.66666667 C5.33333333,9.03485647 5.63181017,9.33333333 6,9.33333333 L9.33333333,9.33333333 C9.70152313,9.33333333 10,9.03485647 10,8.66666667 C10,8.29847687 9.70152313,8 9.33333333,8 L6,8 Z'
        />
      </g>
    </svg>
  )
}

export const AngleRight = (props: any) => {
  const { fill = Colors.blue } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' height='18' width='18'>
      <g fill='none' fillRule='evenodd'>
        <path
          fill={fill}
          fillRule='nonzero'
          d='M5.03032987,11.7803298 C4.73743666,12.073223 4.26256292,12.073223 3.9696697,11.7803298 C3.67677649,11.4874366 3.67677649,11.0125628 3.9696697,10.7196696 L8.46966969,6.2196696 C8.75360394,5.93573539 9.21079374,5.92580118 9.50679324,6.19713408 L14.0067932,10.3221341 C14.3121325,10.6020284 14.3327597,11.0764539 14.0528654,11.3817931 C13.7729711,11.6871324 13.2985456,11.7077596 12.9932063,11.4278653 L9.02255656,7.78810303 L5.03032987,11.7803298 Z'
          transform='rotate(90 9.000002 8.999999)'
        />
      </g>
    </svg>
  )
}

export const PlusIcon = (props: any) => {
  const { fill = Colors.blue } = props

  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='18' width='18'>
      <defs />
      <path
        fill={fill}
        d='M12 23.5A11.5 11.5 0 10.5 12 11.513 11.513 0 0012 23.5zM6 11h4.75a.25.25 0 00.25-.25V6a1 1 0 012 0v4.75a.25.25 0 00.25.25H18a1 1 0 010 2h-4.75a.25.25 0 00-.25.25V18a1 1 0 01-2 0v-4.75a.25.25 0 00-.25-.25H6a1 1 0 010-2z'
      />
    </svg>
  )
}

export const DoubleCheck = (props: any) => {
  const { fill = Colors.textAccent, singleCheck = false, width = 24, ...rest } = props
  return (
    <svg viewBox={`0 0 ${width} ${width}`} {...rest}>
      <g fill={fill} fillRule='nonzero'>
        {!singleCheck && (
          <path
            d='M20.738 5.352a1 1 0 111.524 1.296l-8.5 10a1 1 0 01-1.426.1l-4.5-4a1 1 0 011.328-1.495l3.736 3.32 7.838-9.22z'
            opacity={0.3}
          />
        )}
        <path d='M15.738 6.352a1 1 0 111.524 1.296l-8.5 10a1 1 0 01-1.426.1l-4.5-4a1 1 0 111.328-1.495l3.736 3.32 7.838-9.22z' />
      </g>
    </svg>
  )
}

export const WelcomeIcon = (props: any) => {
  const { fill = Colors.iconBlue } = props
  return (
    <svg width={18} height={18} viewBox='0 0 18 18' {...props}>
      <defs>
        <path
          d='M3.957 8.415L11.48 3.82a1 1 0 011.042 0l7.522 4.596A2 2 0 0121 10.122V19a2 2 0 01-2 2H5a2 2 0 01-2-2v-8.878a2 2 0 01.957-1.707zM10 13a1 1 0 00-1 1v3a1 1 0 001 1h4a1 1 0 001-1v-3a1 1 0 00-1-1h-4z'
          id='WelcomeIcon__a'
        />
      </defs>
      <use
        fill={fill}
        fillRule='nonzero'
        xlinkHref='#WelcomeIcon__a'
        transform='translate(-3 -3)'
      />
    </svg>
  )
}

export const ChatIcon = (props: any) => {
  const { fill = Colors.textAccent } = props
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='36px'
      width='36px'
      viewBox='0 10 100 40'
      enableBackground='new 0 0 100 63.62'
      {...props}
    >
      <path
        fill={fill}
        d='M40.592,41.293V23.226c0-4.67,3.617-8.457,8.079-8.457h17.675v-4.307C66.346,4.685,61.868,0,56.35,0H9.996  C4.477,0,0,4.685,0,10.463v22.354c0,5.777,4.477,10.463,9.996,10.463h7.649c0,4.115,0,8.234,0,12.352  c0,0.682,0.936,1.162,1.422,0.59c3.645-4.314,7.287-8.627,10.933-12.941h10.825C40.677,42.641,40.592,41.979,40.592,41.293z'
      />
      <path
        fill={fill}
        d='M45.178,26.205v20.168c0,4.211,3.263,7.627,7.289,7.627h19.21c2.658,3.145,5.313,6.289,7.97,9.434  c0.354,0.42,1.036,0.068,1.036-0.428c0-3.002,0-6.004,0-9.006h12.029c4.025,0,7.288-3.416,7.288-7.627V26.205  c0-4.212-3.263-7.629-7.288-7.629H52.467C48.441,18.576,45.178,21.992,45.178,26.205z'
      />
    </svg>
  )
}

export const AddUserIcon = (props: any) => {
  const { fill = Colors.textAccent } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height={24} width={24}>
      <defs />
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path
          fill={fill}
          fillRule='nonzero'
          d='M18 8h-2c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1h2V4c0-.55228475.4477153-1 1-1s1 .44771525 1 1v2h2c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-2v2c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1V8zm-9 3c-2.209139 0-4-1.790861-4-4s1.790861-4 4-4 4 1.790861 4 4-1.790861 4-4 4z'
          opacity='1'
        />
        <path
          fill={fill}
          fillRule='nonzero'
          d='M.00065168 20.1992055C.38825853 15.4265159 4.26191235 13 8.98334134 13c4.78787506 0 8.72154236 2.2931929 9.01457296 7.2.0116736.1954741 0 .8-.7512144.8H.72750223c-.25079008 0-.74796398-.54082-.72685055-.8007945z'
        />
      </g>
    </svg>
  )
}

export const DataChecklistIcon = (props: any) => {
  const { fill = Colors.textAccent } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
      <defs />
      <g fill='none' fillRule='evenodd'>
        <path
          fill={fill}
          fillRule='nonzero'
          d='M8 3v.5C8 4.32842712 8.67157288 5 9.5 5h5c.8284271 0 1.5-.67157288 1.5-1.5V3h2c1.1045695 0 2 .8954305 2 2v16c0 1.1045695-.8954305 2-2 2H6c-1.1045695 0-2-.8954305-2-2V5c0-1.1045695.8954305-2 2-2h2zm7.3791667 7.2875c-.3833334-.38333333-.9583334-.38333333-1.3416667 0L10.875 13.45l-1.24583333-1.2458333c-.33541667-.3833334-.95833334-.3833334-1.34166667 0-.38333333.3833333-.38333333.9583333 0 1.3416666L10.2041667 15.4625c.1916666.1916667.43125.2875.6708333.2875.2395833 0 .4791667-.0958333.6708333-.2875l3.8333334-3.8333333c.3833333-.3833334.3833333-.9583334 0-1.3416667z'
        />
        <path
          fill={fill}
          fillRule='nonzero'
          d='M11 2c0-.55228475.4477153-1 1-1s1 .44771525 1 1h1.5c.2761424 0 .5.22385763.5.5v1c0 .27614237-.2238576.5-.5.5h-5c-.27614237 0-.5-.22385763-.5-.5v-1c0-.27614237.22385763-.5.5-.5H11z'
        />
      </g>
    </svg>
  )
}

export const FolderDownloadAlt = (props: any) => {
  const { fill = Colors.textAccent } = props
  return (
    <svg width='28' height='24' xmlns='http://www.w3.org/2000/svg'>
      <g fill={fill} fillRule='nonzero'>
        <path
          id='folder'
          d='M2.5 2h4.573a.5.5 0 01.447.276L8.33 3.9A2 2 0 0010.118 5H19a.5.5 0 01.5.5v4.08c0 .11.074.205.179.233.504.142.993.334 1.46.573a.244.244 0 00.361-.215V5a2 2 0 00-2-2h-9.073a.5.5 0 01-.447-.276l-.81-1.619A2 2 0 007.382 0H2a2 2 0 00-2 2v14.5a2 2 0 002 2h7.3a.245.245 0 00.25-.255c-.018-.4-.018-1.086 0-1.49a.245.245 0 00-.25-.255H2.5A.5.5 0 012 16V2.5a.5.5 0 01.5-.5z'
        />
        <path
          id='arrow'
          d='M24 17.5a6.5 6.5 0 10-6.5 6.5 6.508 6.508 0 006.5-6.5zm-5.688 2.391a.5.5 0 01-.812-.391v-.75a.25.25 0 00-.25-.25H14.5a1 1 0 010-2h2.75a.25.25 0 00.25-.25v-.75a.5.5 0 01.813-.391l2.5 2a.518.518 0 010 .782l-2.501 2z'
        />
      </g>
    </svg>
  )
}

export const FilesIcon = (props: any) => {
  const { fill = Colors.iconBlue } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
      <defs />
      <g fill='none' fillRule='evenodd'>
        <path
          fill={fill}
          fillRule='nonzero'
          d='M3.5 21h17c.8284271 0 1.5-.6715729 1.5-1.5v-11c0-.82842712-.6715729-1.5-1.5-1.5H10L7.43933983 4.43933983C7.15803526 4.15803526 6.77650439 4 6.37867966 4H3.5C2.67157288 4 2 4.67157288 2 5.5v14c0 .8284271.67157288 1.5 1.5 1.5z'
        />
      </g>
    </svg>
  )
}

export const SheetIcon = (props: any) => {
  const { fill = Colors.iconBlue } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
      <defs />
      <g fill='none' fillRule='evenodd'>
        <path
          fill={fill}
          fillRule='nonzero'
          d='M4.5 20c-.8268 0-1.5-.664889-1.5-1.481481V5.481481C3 4.664889 3.6732 4 4.5 4h15c.826801 0 1.5.664889 1.5 1.481481v13.037038C21 19.335111 20.326801 20 19.5 20h-15zm14.7-1.777778v-3.555555h-9v3.555555h9zm-10.8 0v-3.555555H4.8000001v3.555555H8.4zm10.8-5.333333V9.333333h-9v3.555556h9zm-10.8 0V9.333333H4.8000001v3.555556H8.4zm10.800001-5.333333V5.777778H4.8000001v1.777778H19.200001z'
        />
      </g>
    </svg>
  )
}

export const CheckCircleIcon = (props: any) => {
  return (
    <svg width={16} height={16} viewBox='0 0 16 16' {...props}>
      <path
        d='M8 0a8 8 0 108 8 8.01 8.01 0 00-8-8zm4.618 5.467l-4.563 6.192a.674.674 0 01-.954.126L3.843 9.179a.667.667 0 11.833-1.041l2.717 2.174 4.152-5.634a.667.667 0 111.073.789z'
        fill='#26A65B'
        fillRule='nonzero'
      />
    </svg>
  )
}

export const RemoveCircleIcon = (props: any) => {
  return (
    <svg width={16} height={17} viewBox='0 0 16 17' {...props}>
      <g fill='#AFBED0' fillRule='nonzero'>
        <path d='M.166 8.5A7.834 7.834 0 108 .666 7.843 7.843 0 00.166 8.5zm14 0a6.167 6.167 0 11-12.337 0 6.167 6.167 0 0112.338 0h-.001z' />
        <path d='M5.889 5.21A.833.833 0 104.71 6.39l1.993 1.992a.167.167 0 010 .236L4.71 10.611a.833.833 0 101.179 1.178L7.88 9.797a.166.166 0 01.236 0l1.994 1.992a.833.833 0 101.178-1.178L9.296 8.618a.167.167 0 010-.236l1.993-1.993a.833.833 0 10-1.178-1.178L8.117 7.204a.167.167 0 01-.236 0L5.89 5.211z' />
      </g>
    </svg>
  )
}

export const ExpandDiagonal = (props: any) => {
  const { fill = Colors.textAccent } = props
  return (
    <svg viewBox='0 0 12 12' width='100%' xmlns='http://www.w3.org/2000/svg' overflow='visible'>
      <path
        fill={fill}
        d='M0 17.5c0 .6.4 1 1 1h7c.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7l-2.4-2.4c-.1-.1-.1-.3 0-.4L14 6.3c.1-.1.3-.1.4 0l2.4 2.4c.2.2.4.3.7.3.1 0 .3 0 .4-.1.4-.2.6-.5.6-.9V1c0-.6-.4-1-1-1h-7c-.6 0-1 .4-1 1 0 .3.1.5.3.7l2.4 2.4c.1.1.1.3 0 .4l-7.7 7.7c-.1.1-.3.1-.4 0L1.7 9.8c-.4-.4-1-.4-1.4 0-.2.2-.3.4-.3.7v7z'
      />
    </svg>
  )
}

export const DownArrowIcon = (props: any) => {
  const { fill = Colors.textAccent } = props
  return (
    <svg width={14} height={8} viewBox='0 0 14 8' {...props}>
      <path
        d='M12.293.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5A1 1 0 111.676.763L6.97 5.616 12.293.293z'
        fill={fill}
        fillRule='nonzero'
      />
    </svg>
  )
}

export const PaperInkIcon = (props: any) => {
  return (
    <svg width={76} height={68} viewBox='0 0 76 68' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path
          d='M8.203 65.27c0 1.15 8.291 2.173 18.515 2.173 10.223 0 18.515-.977 18.515-2.174 0-1.196-8.292-2.219-18.515-2.219-10.224 0-18.515 1.012-18.515 2.22z'
          fill='#D6DAFF'
          fillRule='nonzero'
        />
        <path
          d='M39.08 64.534a5.819 5.819 0 01-5.819-5.82V26.71a5.819 5.819 0 00-5.819-5.819H7.075a5.819 5.819 0 015.82 5.819v32.005a5.819 5.819 0 005.819 5.819H39.08z'
          fill='#FFF'
          fillRule='nonzero'
        />
        <path
          d='M12.895 26.71a5.819 5.819 0 10-11.639 0v6.681c0 .73.593 1.323 1.323 1.323h10.35l-.035-8.004z'
          stroke='#005CB9'
          fill='#D6DAFF'
          fillRule='nonzero'
          strokeLinejoin='round'
        />
        <path
          d='M39.08 64.534h0a5.819 5.819 0 01-5.819-5.82V26.71a5.819 5.819 0 00-5.819-5.819H7.075a5.819 5.819 0 015.82 5.819v32.005a5.819 5.819 0 005.819 5.819H39.08z'
          stroke='#005CB9'
          strokeLinejoin='round'
        />
        <path
          d='M39.08 64.534a5.819 5.819 0 005.75-6.383 5.992 5.992 0 00-5.98-5.256H22.635a.667.667 0 00-.391 1.15 5.819 5.819 0 01-3.53 10.442l20.366.047z'
          stroke='#005CB9'
          fill='#FFF'
          fillRule='nonzero'
          strokeLinejoin='round'
        />
        <path
          stroke='#005CB9'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M28.902 29.619H17.989M28.902 33.989H17.989M26.982 38.348h-5.819M26.982 42.718h-4.359'
        />
        <path
          fill='#D6DAFF'
          fillRule='nonzero'
          d='M45.853 35.634l-6.163-6.175 5.14-7.2 8.223 8.235zM53.064 30.494l-8.234-8.235L68.094 1.744a4.209 4.209 0 015.889 6.003L53.064 30.494z'
        />
        <path
          d='M38.344 43.764a3.956 3.956 0 01-3.117 1.587c-1.931 0-4.921.3-6.9 1.599 1.288-1.944 1.564-4.922 1.587-6.9a3.967 3.967 0 011.599-3.116L38.148 32l5.141 5.14-4.945 6.624z'
          fill='#FFF'
          fillRule='nonzero'
        />
        <path
          stroke='#005CB9'
          fill='#FFF'
          fillRule='nonzero'
          strokeLinejoin='round'
          d='M43.289 37.175l-5.152-5.14 1.553-2.576 6.163 6.175z'
        />
        <path
          d='M38.344 43.764a3.956 3.956 0 01-3.117 1.587c-1.931 0-4.921.3-6.9 1.599 1.288-1.944 1.564-4.922 1.587-6.9a3.967 3.967 0 011.599-3.116L38.148 32l5.141 5.14-4.945 6.624zM45.853 35.634l-6.163-6.175 5.14-7.2 8.223 8.235z'
          stroke='#005CB9'
          strokeLinejoin='round'
        />
        <path
          d='M36.09 41.292a1.46 1.46 0 01-2.488-1.03c0-.386.155-.756.43-1.029a1.46 1.46 0 012.058 2.059h0z'
          stroke='#4550E5'
          fill='#D6DAFF'
          fillRule='nonzero'
          strokeLinejoin='round'
        />
        <path stroke='#4550E5' strokeLinejoin='round' d='M34.032 41.292l-5.141 5.14' />
        <path
          d='M72.28 9.598l.932.92a2.921 2.921 0 01.092 4.025l-8.924 9.775'
          stroke='#005CB9'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          stroke='#4550E5'
          fill='#FFF'
          fillRule='nonzero'
          strokeLinejoin='round'
          d='M47.015 20.328l-2.185 1.931 8.223 8.235 1.978-2.151z'
        />
        <path
          d='M53.064 30.494l-8.234-8.235L68.094 1.744a4.209 4.209 0 015.889 6.003L53.064 30.494z'
          stroke='#005CB9'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export const InviteIcon = (props: any) => {
  return (
    <svg width={24} height={24} viewBox='0 0 24 24' {...props}>
      <g fill='#005CB9' fillRule='nonzero'>
        <path d='M18.409 15.131a.754.754 0 01-.4.119H6a.754.754 0 01-.4-.119l-5.215-3.35a.25.25 0 00-.385.21V22a2 2 0 002 2h20a2 2 0 002-2V11.993a.25.25 0 00-.385-.211l-5.206 3.349z' />
        <path
          d='M5.115 13.041a.25.25 0 00.385-.21V2.25A.25.25 0 015.75 2h12.5a.25.25 0 01.25.25v10.575a.25.25 0 00.385.211l4.063-2.608a.25.25 0 00.008-.416L20.5 8.3V2.206a2.114 2.114 0 00-2-2.208h-13a2.115 2.115 0 00-2 2.209V8.3l-2.458 1.71a.25.25 0 00.007.416l4.066 2.615z'
          opacity={0.5}
        />
        <path d='M11.243 5a.75.75 0 00-.75-.75h-2a.75.75 0 000 1.5h2a.75.75 0 00.75-.75zM7.75 8.5c0 .414.336.75.75.75h7a.75.75 0 100-1.5h-7a.75.75 0 00-.75.75zM8.5 12.75h7a.75.75 0 100-1.5h-7a.75.75 0 100 1.5z' />
      </g>
    </svg>
  )
}

export const SettingsIcon = (props: any) => {
  const { fill = Colors.iconBlue } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
      <defs />
      <g fill='none' fillRule='evenodd'>
        <path
          fill={fill}
          fillRule='nonzero'
          d='M12 3c1.2426407 0 2.25 1.00735931 2.25 2.25l-.000006.06450877c.000775.19430359.116861.36959346.30283.44934429.1823221.080466.395263.04185583.5318459-.09168315l.0447051-.04470492c.4220286-.42249834.9947042-.65989497 1.591875-.65989497.5971708 0 1.1698464.23739663 1.591285.65930498.4224984.42202858.659895.99470419.659895 1.591875 0 .59717081-.2373966 1.16984642-.6595999 1.59158009l-.0391832.03911863c-.1393558.14246426-.177966.35540521-.0975.53772727l.0227033.10767065c.0842601.15556649.2471351.25444386.4236498.25515336h.1275C19.9926407 9.75 21 10.7573593 21 12s-1.0073593 2.25-2.25 2.25l-.0645088-.000006c-.1943036.000775-.3695934.116861-.4461363.2954546-.083674.1896975-.0450638.4026384.0884752.5392213l.0447049.0447051c.4224984.4220286.659895.9947042.659895 1.591875 0 .5971708-.2373966 1.1698464-.659305 1.591285-.4220286.4224984-.9947042.659895-1.591875.659895-.5971708 0-1.1698464-.2373966-1.5915801-.6595999l-.0391186-.0391832c-.1424643-.1393558-.3554052-.177966-.5451027-.094292-.1785936.0765429-.2946796.2518327-.2954486.4431451v.1275c0 1.2426407-1.0073593 2.25-2.25 2.25s-2.25-1.0073593-2.25-2.25c-.00447591-.2500815-.13101461-.4270014-.36282401-.5138531-.18232206-.080466-.39526301-.0418558-.5318459.0916832l-.04470509.0447049c-.42202858.4224984-.99470419.659895-1.591875.659895-.59717081 0-1.16984642-.2373966-1.59128501-.659305-.42249834-.4220286-.65989497-.9947042-.65989497-1.591875 0-.5971708.23739663-1.1698464.65959989-1.5915801l.03918315-.0391186c.13935583-.1424643.177966-.3554052.09429207-.5451027C5.74410223 14.426855 5.56881236 14.310769 5.3775 14.31H5.25C4.00735931 14.31 3 13.3026407 3 12.06s1.00735931-2.25 2.25-2.25c.25008154-.00447591.42700139-.13101461.51385306-.36282401.080466-.18232206.04185583-.39526301-.09168315-.5318459L5.62746499 8.870625c-.42249834-.42202858-.65989497-.99470419-.65989497-1.591875 0-.59717081.23739663-1.16984642.65930498-1.59128501.42202858-.42249834.99470419-.65989497 1.591875-.65989497.59717081 0 1.16984642.23739663 1.59158009.65959989l.03911863.03918315c.14246426.13935583.35540521.177966.53772727.0975l.10767065-.02270329C9.65041313 5.71688974 9.7492905 5.55401473 9.75 5.3775V5.25C9.75 4.00735931 10.7573593 3 12 3zm0 6c-1.6568542 0-3 1.3431458-3 3s1.3431458 3 3 3 3-1.3431458 3-3-1.3431458-3-3-3z'
        />
      </g>
    </svg>
  )
}

export const ArchiveIcon = (props: any) => {
  const { primaryFill = Colors.text80, secondaryFill = '#424E58' } = props
  return (
    <svg {...props} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.5 5H32.5C33.8807 5 35 6.11929 35 7.5V32.5C35 33.8807 33.8807 35 32.5 35H7.5C6.11929 35 5 33.8807 5 32.5V7.5C5 6.11929 6.11929 5 7.5 5ZM13.3333 8.33333C12.4129 8.33333 11.6667 9.07953 11.6667 10C11.6667 10.9205 12.4129 11.6667 13.3333 11.6667H26.6667C27.5871 11.6667 28.3333 10.9205 28.3333 10C28.3333 9.07953 27.5871 8.33333 26.6667 8.33333H13.3333Z'
        fill={primaryFill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M26.3031 23.0025C26.5782 22.6776 26.3473 22.1795 25.9215 22.1795H21.9418V18.5C21.9418 18.2239 21.7179 18 21.4418 18H19.0696C18.7934 18 18.5696 18.2239 18.5696 18.5V22.1795L14.5898 22.1795C14.1641 22.1795 13.9331 22.6776 14.2082 23.0025L19.8741 29.6945C20.0738 29.9304 20.4376 29.9304 20.6373 29.6945L26.3031 23.0025Z'
        fill={secondaryFill}
      />
    </svg>
  )
}

export const RestoreIcon = (props: any) => {
  const { primaryFill = '#B2BECE', secondaryFill = '#454E57' } = props
  return (
    <svg {...props} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.44'
        d='M3.71429 0H20.0221C20.3768 0 20.72 0.125684 20.9908 0.35474L31.4687 9.21728C31.8057 9.50228 32 9.92121 32 10.3625V36.1667C32 39.7478 31.9591 40 28.2857 40H3.71429C0.0408957 40 0 39.7478 0 36.1667V3.83333C0 0.25225 0.0408957 0 3.71429 0Z'
        fill={primaryFill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.9739 17.3362C14.9885 17.1465 15.1466 17 15.3369 17V17C15.5239 17 15.6806 17.1417 15.6992 17.3279L15.9997 20.3333L18.1553 21.5651C18.2652 21.6279 18.3331 21.7448 18.3331 21.8714V21.8714C18.3331 22.104 18.1118 22.273 17.8874 22.2118L15.065 21.4421C14.8337 21.379 14.6797 21.1605 14.6981 20.9213L14.9739 17.3362Z'
        fill={secondaryFill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.3471 13.1994C12.083 12.8847 11.5731 13.0052 11.4777 13.4048L10.8542 16.0189C10.7765 16.3446 11.0346 16.6531 11.3688 16.6342L14.058 16.4818C14.4689 16.4585 14.6773 15.9764 14.4127 15.6612L13.8325 14.9697C14.415 14.7706 15.0327 14.6667 15.667 14.6667C18.7966 14.6667 21.3337 17.2037 21.3337 20.3333C21.3337 23.4629 18.7966 26 15.667 26C12.5374 26 10.0003 23.4629 10.0003 20.3333C10.0003 19.8079 10.0715 19.2934 10.2102 18.7988L8.92641 18.4387C8.75739 19.0413 8.66699 19.6767 8.66699 20.3333C8.66699 24.1993 11.801 27.3333 15.667 27.3333C19.533 27.3333 22.667 24.1993 22.667 20.3333C22.667 16.4673 19.533 13.3333 15.667 13.3333C14.6945 13.3333 13.7683 13.5316 12.9266 13.8901L12.3471 13.1994Z'
        fill={secondaryFill}
      />
    </svg>
  )
}

export const EmbedUploadIcon = (props: any) => {
  const { fill = '#3B2FC9' } = props
  return (
    <svg {...props} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.5 21C2.67157 21 2 20.3284 2 19.5V5.5C2 4.67157 2.67157 4 3.5 4H6.37868C6.7765 4 7.15804 4.15804 7.43934 4.43934L10 7H20.5C21.3284 7 22 7.67157 22 8.5V19.5C22 20.3284 21.3284 21 20.5 21H3.5ZM8.54302 14.4923C8.1092 14.4923 7.88121 13.9777 8.17269 13.6564L11.3797 10.1211C11.5781 9.90237 11.9219 9.90237 12.1203 10.1211L15.3273 13.6564C15.6188 13.9777 15.3908 14.4923 14.957 14.4923H12.8339V16.5C12.8339 16.7761 12.6101 17 12.3339 17H11.1661C10.89 17 10.6661 16.7761 10.6661 16.5V14.4923H8.54302Z'
        fill={fill}
      />
    </svg>
  )
}

export const SuccessCheck = (props: any) => {
  const { circle = '#377D3D', check = '#fff' } = props
  return (
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='12' cy='12' r='10' fill={circle} />
      <path
        d='M16.769 7.81769C17.1458 7.41393 17.7786 7.39211 18.1823 7.76895C18.5861 8.14578 18.6079 8.77857 18.2311 9.18232L11.2311 16.6823C10.8655 17.074 10.2561 17.108 9.84923 16.7593L6.34923 13.7593C5.9299 13.3998 5.88134 12.7685 6.24076 12.3492C6.60018 11.9299 7.23148 11.8813 7.65081 12.2407L10.423 14.6169L16.769 7.81769Z'
        fill={check}
      />
    </svg>
  )
}

export const CloseIcon = (props: any) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={18} height={18} {...props}>
    <path
      fill='#AFBED0'
      d='m14.53 4.53-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z'
    />
  </svg>
)

export const DownArrowTriangle = (props: any) => (
  <svg width={15} height={11} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M7.868 10.085a1 1 0 0 1-1.572 0l-5.94-7.55A1 1 0 0 1 1.14.917h11.882a1 1 0 0 1 .786 1.618l-5.941 7.55Z'
      fill='#616A7D'
    />
  </svg>
)

export const LinkIcon = (props: any) => {
  const { fill = Colors.iconGray, ...restProps } = props
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M9.06871 2.66873C9.69355 2.04389 10.7066 2.04389 11.3315 2.66873C11.9563 3.29357 11.9563 4.30663 11.3315 4.93147L8.93145 7.33147C8.30661 7.95631 7.29355 7.95631 6.66871 7.33147C6.35629 7.01905 5.84976 7.01905 5.53734 7.33147C5.22492 7.64389 5.22492 8.15042 5.53734 8.46284C6.78702 9.71252 8.81315 9.71252 10.0628 8.46284L12.4628 6.06284C13.7125 4.81316 13.7125 2.78703 12.4628 1.53736C11.2131 0.287678 9.18702 0.287678 7.93734 1.53736L6.73734 2.73736C6.42492 3.04978 6.42492 3.55631 6.73734 3.86873C7.04976 4.18115 7.55629 4.18115 7.86871 3.86873L9.06871 2.66873Z'
        fill={fill}
      />
      <path
        d='M5.06873 6.66873C5.69356 6.04389 6.70663 6.04389 7.33147 6.66873C7.64389 6.98115 8.15042 6.98115 8.46284 6.66873C8.77526 6.35631 8.77526 5.84977 8.46284 5.53736C7.21316 4.28768 5.18703 4.28768 3.93736 5.53736L1.53736 7.93736C0.287678 9.18703 0.287678 11.2132 1.53736 12.4628C2.78703 13.7125 4.81316 13.7125 6.06284 12.4628L7.26284 11.2628C7.57526 10.9504 7.57526 10.4439 7.26284 10.1315C6.95042 9.81905 6.44389 9.81905 6.13147 10.1315L4.93147 11.3315C4.30663 11.9563 3.29357 11.9563 2.66873 11.3315C2.04389 10.7066 2.04389 9.69357 2.66873 9.06873L5.06873 6.66873Z'
        fill={fill}
      />
    </svg>
  )
}

export const InfoIcon = ({
  fill = Colors.grayText,
  ...props
}: HTMLAttributes<SVGElement> & { fill?: string }) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55229 6.44772 9 7 9V12C7 12.5523 7.44772 13 8 13H9C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11V8C9 7.44772 8.55228 7 8 7H7Z'
        fill={fill}
      />
    </svg>
  )
}

export const SearchIcon = (props: any) => (
  <svg
    {...props}
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19 19L13 13M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z'
      stroke='#8B93A4'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const RightChevron = ({ expanded: boolean, ...rest }: any) => {
  return (
    <svg
      width='6'
      height='10'
      viewBox='0 0 6 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.35685e-07 8.56728C4.59565e-07 8.9965 0.50521 9.22622 0.828665 8.94408L4.9027 5.39051C5.13068 5.19166 5.13123 4.83749 4.90387 4.63793L0.829837 1.06194C0.50671 0.77832 1.51023e-08 1.00777 3.90229e-08 1.43772L4.35685e-07 8.56728Z'
        fill='#616A7D'
      />
    </svg>
  )
}

export const ClearIndicatorIcon = ({
  color = 'white',
  backgroundColor,
  fill = '#616A7D',
  ...props
}: any) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <ellipse
        cx='9.99995'
        cy='9.99984'
        rx='8.33332'
        ry='8.33333'
        fill={backgroundColor || fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.49413 6.49408C6.16869 6.81951 6.16869 7.34715 6.49413 7.67259L8.85122 10.0297L6.49408 12.3868C6.16864 12.7123 6.16864 13.2399 6.49408 13.5653C6.81951 13.8908 7.34715 13.8908 7.67259 13.5654L10.0297 11.2082L12.3867 13.5651C12.7121 13.8906 13.2398 13.8906 13.5652 13.5651C13.8906 13.2397 13.8906 12.7121 13.5652 12.3866L11.2082 10.0297L13.5651 7.67279C13.8906 7.34736 13.8906 6.81972 13.5651 6.49428C13.2397 6.16884 12.7121 6.16884 12.3866 6.49428L10.0297 8.85118L7.67264 6.49408C7.3472 6.16864 6.81956 6.16864 6.49413 6.49408Z'
        fill={color}
      />
    </svg>
  )
}

export const BreadcrumbArrow = ({ fill = '#CAD0DC', ...props }: any) => (
  <svg
    width='7'
    height='11'
    viewBox='0 0 7 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.625 5.5C6.62517 5.63596 6.59632 5.77039 6.5404 5.89432C6.48447 6.01825 6.40274 6.12884 6.30066 6.21869L1.66434 10.2968C1.58907 10.3661 1.5007 10.4197 1.40441 10.4545C1.30812 10.4892 1.20586 10.5043 1.10364 10.4989C1.00142 10.4936 0.901306 10.4679 0.809175 10.4233C0.717044 10.3787 0.634759 10.3161 0.567157 10.2393C0.499554 10.1625 0.447998 10.0729 0.415519 9.97587C0.38304 9.87883 0.370292 9.77629 0.378026 9.67425C0.38576 9.57222 0.413819 9.47277 0.460555 9.38173C0.50729 9.2907 0.571759 9.20992 0.650171 9.14414L4.70435 5.57814C4.71549 5.56839 4.7244 5.55637 4.73052 5.5429C4.73663 5.52942 4.73979 5.5148 4.73979 5.5C4.73979 5.4852 4.73663 5.47058 4.73052 5.4571C4.7244 5.44362 4.71549 5.43161 4.70435 5.42185L0.649339 1.85585C0.570927 1.79008 0.506459 1.7093 0.459724 1.61827C0.412988 1.52723 0.384929 1.42777 0.377195 1.32574C0.369461 1.22371 0.382208 1.12116 0.414687 1.02413C0.447167 0.927093 0.498724 0.837526 0.566326 0.760693C0.633929 0.68386 0.716213 0.621312 0.808344 0.576723C0.900474 0.532135 1.00059 0.506407 1.10281 0.501052C1.20503 0.495697 1.30729 0.510822 1.40358 0.545538C1.49987 0.580255 1.58824 0.633863 1.66351 0.703211L6.299 4.78007C6.40133 4.87008 6.48332 4.98082 6.53953 5.10495C6.59573 5.22908 6.62487 5.36375 6.625 5.5V5.5Z'
      fill={fill}
    />
  </svg>
)

export const AddIcon = ({
  fill = '#3B2FC9',
  ...props
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5 1V5M5 5V9M5 5H9M5 5L1 5'
      stroke={fill}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const DangerIcon = ({
  fill = Colors.dangerStrong,
  ...props
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg
    width='16'
    height='14'
    viewBox='0 0 16 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.25706 1.09882C7.02167 -0.26048 8.97875 -0.260481 9.74336 1.09882L15.3237 11.0194C16.0736 12.3526 15.1102 13.9999 13.5805 13.9999H2.4199C0.890251 13.9999 -0.0731769 12.3526 0.676753 11.0194L6.25706 1.09882ZM9.00012 11C9.00012 11.5523 8.55241 12 8.00012 12C7.44784 12 7.00012 11.5523 7.00012 11C7.00012 10.4477 7.44784 10 8.00012 10C8.55241 10 9.00012 10.4477 9.00012 11ZM8.00012 3C7.44784 3 7.00012 3.44772 7.00012 4V7C7.00012 7.55228 7.44784 8 8.00012 8C8.55241 8 9.00012 7.55228 9.00012 7V4C9.00012 3.44772 8.55241 3 8.00012 3Z'
      fill={fill}
    />
  </svg>
)

export const ErrorIcon = ({
  fill = Colors.dangerStrong,
  ...props
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L6.58579 8L5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071C5.68342 11.0976 6.31658 11.0976 6.70711 10.7071L8 9.41421L9.29289 10.7071C9.68342 11.0976 10.3166 11.0976 10.7071 10.7071C11.0976 10.3166 11.0976 9.68342 10.7071 9.29289L9.41421 8L10.7071 6.70711C11.0976 6.31658 11.0976 5.68342 10.7071 5.29289C10.3166 4.90237 9.68342 4.90237 9.29289 5.29289L8 6.58579L6.70711 5.29289Z'
      fill={fill}
    />
  </svg>
)

export const IconToggleOff = ({
  fill = Colors.pigeon600
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='12' height='12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='m6 6 2 2M4 8l2-2-2 2Zm2-2 2-2-2 2Zm0 0L4 4l2 2Z'
      stroke={fill}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
export const IconToggleOn = ({
  fill = Colors.brandPrimary
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='12' height='12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.707 5.293a1 1 0 0 0-1.414 1.414l1.414-1.414ZM5 8l-.707.707a1 1 0 0 0 1.414 0L5 8Zm4.707-3.293a1 1 0 0 0-1.414-1.414l1.414 1.414Zm-7.414 2 2 2 1.414-1.414-2-2-1.414 1.414Zm3.414 2 4-4-1.414-1.414-4 4 1.414 1.414Z'
      fill={fill}
    />
  </svg>
)

export const BookOpen = ({
  fill = Colors.brandPrimary
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12 6.25278V19.2528M12 6.25278C10.8321 5.47686 9.24649 5 7.5 5C5.75351 5 4.16789 5.47686 3 6.25278V19.2528C4.16789 18.4769 5.75351 18 7.5 18C9.24649 18 10.8321 18.4769 12 19.2528M12 6.25278C13.1679 5.47686 14.7535 5 16.5 5C18.2465 5 19.8321 5.47686 21 6.25278V19.2528C19.8321 18.4769 18.2465 18 16.5 18C14.7535 18 13.1679 18.4769 12 19.2528'
      stroke={fill}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const SparklesIcon = ({
  fill = '#FFD152'
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.99998 0.599609C3.4418 0.599609 3.79998 0.957782 3.79998 1.39961V2.19961H4.59998C5.0418 2.19961 5.39998 2.55778 5.39998 2.99961C5.39998 3.44144 5.0418 3.79961 4.59998 3.79961H3.79998V4.59961C3.79998 5.04144 3.4418 5.39961 2.99998 5.39961C2.55815 5.39961 2.19998 5.04144 2.19998 4.59961V3.79961H1.39998C0.958148 3.79961 0.599976 3.44144 0.599976 2.99961C0.599976 2.55778 0.958148 2.19961 1.39998 2.19961H2.19998V1.39961C2.19998 0.957782 2.55815 0.599609 2.99998 0.599609ZM2.99998 8.59961C3.4418 8.59961 3.79998 8.95778 3.79998 9.39961V10.1996H4.59998C5.0418 10.1996 5.39998 10.5578 5.39998 10.9996C5.39998 11.4414 5.0418 11.7996 4.59998 11.7996H3.79998V12.5996C3.79998 13.0414 3.4418 13.3996 2.99998 13.3996C2.55815 13.3996 2.19998 13.0414 2.19998 12.5996V11.7996H1.39998C0.958148 11.7996 0.599976 11.4414 0.599976 10.9996C0.599976 10.5578 0.958148 10.1996 1.39998 10.1996H2.19998V9.39961C2.19998 8.95778 2.55815 8.59961 2.99998 8.59961Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.59993 0.599609C8.96292 0.599609 9.28041 0.843995 9.3733 1.1949L10.3167 4.75875L12.9997 6.30666C13.2474 6.44953 13.3999 6.71371 13.3999 6.99961C13.3999 7.28551 13.2474 7.54969 12.9997 7.69256L10.3167 9.24047L9.3733 12.8043C9.28041 13.1552 8.96292 13.3996 8.59993 13.3996C8.23695 13.3996 7.91945 13.1552 7.82657 12.8043L6.88319 9.24046L4.20019 7.69255C3.95255 7.54968 3.79998 7.28551 3.79998 6.99961C3.79998 6.71371 3.95255 6.44954 4.20019 6.30666L6.88319 4.75876L7.82657 1.1949C7.91945 0.843995 8.23695 0.599609 8.59993 0.599609Z'
      fill={fill}
    />
  </svg>
)

export const MagnifyingGlass = ({
  fill = Colors.pigeon700
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M15.75 15.75L11.25 11.25M12.75 7.5C12.75 10.3995 10.3995 12.75 7.5 12.75C4.60051 12.75 2.25 10.3995 2.25 7.5C2.25 4.60051 4.60051 2.25 7.5 2.25C10.3995 2.25 12.75 4.60051 12.75 7.5Z'
      stroke={fill}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const Duplicate = ({
  fill = Colors.pigeon700
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.33317 10.667H3.99984C3.26346 10.667 2.6665 10.07 2.6665 9.33366V4.00033C2.6665 3.26395 3.26346 2.66699 3.99984 2.66699H9.33317C10.0695 2.66699 10.6665 3.26395 10.6665 4.00033V5.33366M6.6665 13.3337H11.9998C12.7362 13.3337 13.3332 12.7367 13.3332 12.0003V6.66699C13.3332 5.93061 12.7362 5.33366 11.9998 5.33366H6.6665C5.93012 5.33366 5.33317 5.93061 5.33317 6.66699V12.0003C5.33317 12.7367 5.93012 13.3337 6.6665 13.3337Z'
      stroke={fill}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const Pencil = ({
  fill = Colors.pigeon400
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z'
      fill={fill}
    />
    <path d='M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z' fill={fill} />
  </svg>
)

export const Exclamation = ({
  stroke = Colors.dangerStrong
}: HTMLAttributes<SVGElement> & { stroke?: string }) => (
  <svg width='20' height='18' viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.99955 7V9M9.99955 13H10.0095M3.07134 17H16.9277C18.4673 17 19.4296 15.3333 18.6598 14L11.7316 2C10.9618 0.666667 9.0373 0.666667 8.2675 2L1.33929 14C0.569492 15.3333 1.53174 17 3.07134 17Z'
      stroke={stroke}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const Menu = ({
  stroke = Colors.pigeon700
}: HTMLAttributes<SVGElement> & { stroke?: string }) => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.33337 5H16.6667M3.33337 10H16.6667M3.33337 15H16.6667'
      stroke={stroke}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const Eye = ({
  fill = Colors.pigeon600
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg
    data-testid='eye-icon'
    width='20'
    height='20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z' fill={fill} />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z'
      fill={fill}
    />
  </svg>
)

export const NewWindow = ({
  fill = Colors.text
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='16' width='16' fill='none'>
    <defs />
    <path
      stroke={fill}
      d='M8.251 16.498c-.2 0-.389-.078-.53-.22-.292-.292-.292-.768 0-1.061l13.72-13.72h-4.939c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.75c.089 0 .176.016.261.048.011.004.022.008.032.012.176.072.324.221.4.404.003.008.007.017.01.026.031.081.047.17.047.26v6.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75V2.559l-13.72 13.72c-.142.141-.331.219-.531.219z'
    />
    <path
      stroke={fill}
      d='M2.251 23.998c-1.241 0-2.25-1.009-2.25-2.25v-15c0-1.241 1.009-2.25 2.25-2.25h9c.414 0 .75.336.75.75s-.336.75-.75.75h-9c-.414 0-.75.336-.75.75v15c0 .414.336.75.75.75h15c.414 0 .75-.336.75-.75v-9c0-.414.336-.75.75-.75s.75.336.75.75v9c0 1.241-1.009 2.25-2.25 2.25h-15z'
    />
  </svg>
)

export const EyeWithSlash = ({
  fill = Colors.pigeon600
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg
    data-testid='eye-with-slash-icon'
    width='20'
    height='20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.707 2.293a1 1 0 0 0-1.414 1.414l14 14a1 1 0 0 0 1.414-1.414l-1.473-1.473A10.014 10.014 0 0 0 19.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 0 0-4.512 1.074l-1.78-1.781Zm4.261 4.26 1.514 1.515a2.003 2.003 0 0 1 2.45 2.45l1.514 1.514a4 4 0 0 0-5.478-5.478Z'
      fill={fill}
    />
    <path
      d='M12.454 16.697 9.75 13.992a4 4 0 0 1-3.742-3.741L2.335 6.578A9.98 9.98 0 0 0 .458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303Z'
      fill={fill}
    />
  </svg>
)

export const TableIcon = ({
  fill = Colors.pigeon600
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.00001 0.200001C1.67452 0.200001 0.600006 1.27452 0.600006 2.6V7.4C0.600006 8.72548 1.67452 9.8 3.00001 9.8H11C12.3255 9.8 13.4 8.72548 13.4 7.4V2.6C13.4 1.27452 12.3255 0.200001 11 0.200001H3.00001ZM2.20001 7.4V6.6H6.20001V8.2H3.00001C2.55818 8.2 2.20001 7.84183 2.20001 7.4ZM7.80001 8.2H11C11.4418 8.2 11.8 7.84183 11.8 7.4V6.6H7.80001V8.2ZM7.80001 5H11.8V3.4H7.80001V5ZM6.20001 3.4H2.20001V5H6.20001V3.4Z'
      fill={fill}
    />
  </svg>
)

export const ExclamationCircleIcon = ({
  fill = Colors.pigeon600
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7 4.33333V7M7 9.66667H7.00667M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z'
      stroke={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ArrowRightUpDiagonal = ({
  fill = Colors.pigeon400
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7 5.8V1M7 1H2.2M7 1L1 7'
      stroke={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const Lightbulb = ({
  fill = Colors.pigeon100,
  stroke = Colors.pigeon700
}: HTMLAttributes<SVGElement> & { fill?: string; stroke?: string }) => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M6.05368 6.05374C4.42649 7.68093 4.42649 10.3191 6.05368 11.9463L6.50959 12.4022C7.037 12.9296 7.33329 13.6449 7.33329 14.3908V14.8333C7.33329 15.7538 8.07948 16.5 8.99995 16.5C9.92043 16.5 10.6666 15.7538 10.6666 14.8333V14.3908C10.6666 13.6449 10.9629 12.9296 11.4903 12.4022L11.9462 11.9463C13.5734 10.3191 13.5734 7.68093 11.9462 6.05374C10.319 4.42656 7.68086 4.42656 6.05368 6.05374Z'
      fill={fill}
    />
    <path
      d='M7.05289 13.1667H10.947M8.99995 1.5V2.33333M14.3033 3.6967L13.714 4.28596M16.5 8.99996H15.6667M2.33333 8.99996H1.5M4.28591 4.28595L3.69665 3.6967M6.05368 11.9463C4.42649 10.3191 4.42649 7.68093 6.05368 6.05374C7.68086 4.42656 10.319 4.42656 11.9462 6.05374C13.5734 7.68093 13.5734 10.3191 11.9462 11.9463L11.4903 12.4022C10.9629 12.9296 10.6666 13.6449 10.6666 14.3908V14.8333C10.6666 15.7538 9.92043 16.5 8.99995 16.5C8.07948 16.5 7.33329 15.7538 7.33329 14.8333V14.3908C7.33329 13.6449 7.037 12.9296 6.50959 12.4022L6.05368 11.9463Z'
      stroke={stroke}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const LockIcon = ({ fill = Colors.pigeon700, ...props }) => (
  <svg
    width='16'
    height='18'
    viewBox='0 0 16 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.3333 8.16667V8.91667H12.0833V8.16667H11.3333ZM4.66666 8.16667H3.91666V8.91667H4.66666V8.16667ZM8.74999 11.5C8.74999 11.0858 8.41421 10.75 7.99999 10.75C7.58578 10.75 7.24999 11.0858 7.24999 11.5H8.74999ZM7.24999 13.1667C7.24999 13.5809 7.58578 13.9167 7.99999 13.9167C8.41421 13.9167 8.74999 13.5809 8.74999 13.1667H7.24999ZM2.99999 8.91667H13V7.41667H2.99999V8.91667ZM13.9167 9.83333V14.8333H15.4167V9.83333H13.9167ZM13 15.75H2.99999V17.25H13V15.75ZM2.08333 14.8333V9.83333H0.583328V14.8333H2.08333ZM2.99999 15.75C2.49373 15.75 2.08333 15.3396 2.08333 14.8333H0.583328C0.583328 16.168 1.66531 17.25 2.99999 17.25V15.75ZM13.9167 14.8333C13.9167 15.3396 13.5063 15.75 13 15.75V17.25C14.3347 17.25 15.4167 16.168 15.4167 14.8333H13.9167ZM13 8.91667C13.5063 8.91667 13.9167 9.32707 13.9167 9.83333H15.4167C15.4167 8.49864 14.3347 7.41667 13 7.41667V8.91667ZM2.99999 7.41667C1.66531 7.41667 0.583328 8.49864 0.583328 9.83333H2.08333C2.08333 9.32707 2.49373 8.91667 2.99999 8.91667V7.41667ZM10.5833 4.83333V8.16667H12.0833V4.83333H10.5833ZM11.3333 7.41667H4.66666V8.91667H11.3333V7.41667ZM5.41666 8.16667V4.83333H3.91666V8.16667H5.41666ZM7.99999 2.25C9.42673 2.25 10.5833 3.4066 10.5833 4.83333H12.0833C12.0833 2.57817 10.2552 0.75 7.99999 0.75V2.25ZM7.99999 0.75C5.74483 0.75 3.91666 2.57817 3.91666 4.83333H5.41666C5.41666 3.4066 6.57326 2.25 7.99999 2.25V0.75ZM7.24999 11.5V13.1667H8.74999V11.5H7.24999Z'
      fill={fill}
    />
  </svg>
)

export const RightCheckIcon = ({
  fill = sidebarStatusColors.active
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5 7L6.33333 8.33333L9 5.66667M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z'
      stroke={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const DiagonalUpArrow = () => (
  <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M4.3 1.5H8.5M8.5 1.5V5.7M8.5 1.5L1.5 8.5'
      stroke='#4C48EF'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const BlockedIcon = ({
  fill = Colors.brandAccent
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.2426 11.2426C13.5858 8.8995 13.5858 5.10051 11.2426 2.75736C8.8995 0.414213 5.10051 0.414213 2.75736 2.75736M11.2426 11.2426C8.8995 13.5858 5.10051 13.5858 2.75736 11.2426C0.414213 8.8995 0.414213 5.10051 2.75736 2.75736M11.2426 11.2426L2.75736 2.75736'
      stroke={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const DashedCircle = ({
  fill = Colors.pigeon600
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z'
      stroke={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeDasharray='2 3'
    />
  </svg>
)

export const ClipboardIcon = ({
  fill = Colors.pigeon600
}: HTMLAttributes<SVGElement> & { fill?: string }) => (
  <svg width='12' height='14' viewBox='0 0 12 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.99998 6.25C5.58577 6.25 5.24998 6.58579 5.24998 7C5.24998 7.41421 5.58577 7.75 5.99998 7.75V6.25ZM7.99998 7.75C8.41419 7.75 8.74998 7.41421 8.74998 7C8.74998 6.58579 8.41419 6.25 7.99998 6.25V7.75ZM5.99998 8.91667C5.58577 8.91667 5.24998 9.25245 5.24998 9.66667C5.24998 10.0809 5.58577 10.4167 5.99998 10.4167V8.91667ZM7.99998 10.4167C8.41419 10.4167 8.74998 10.0809 8.74998 9.66667C8.74998 9.25245 8.41419 8.91667 7.99998 8.91667V10.4167ZM3.99998 6.25C3.58577 6.25 3.24998 6.58579 3.24998 7C3.24998 7.41421 3.58577 7.75 3.99998 7.75V6.25ZM4.00665 7.75C4.42086 7.75 4.75665 7.41421 4.75665 7C4.75665 6.58579 4.42086 6.25 4.00665 6.25V7.75ZM3.99998 8.91667C3.58577 8.91667 3.24998 9.25245 3.24998 9.66667C3.24998 10.0809 3.58577 10.4167 3.99998 10.4167V8.91667ZM4.00665 10.4167C4.42086 10.4167 4.75665 10.0809 4.75665 9.66667C4.75665 9.25245 4.42086 8.91667 4.00665 8.91667V10.4167ZM9.91665 3.66667V11.6667H11.4166V3.66667H9.91665ZM9.33331 12.25H2.66665V13.75H9.33331V12.25ZM2.08331 11.6667V3.66667H0.583313V11.6667H2.08331ZM2.66665 3.08333H3.99998V1.58333H2.66665V3.08333ZM7.99998 3.08333H9.33331V1.58333H7.99998V3.08333ZM2.66665 12.25C2.34448 12.25 2.08331 11.9888 2.08331 11.6667H0.583313C0.583313 12.8173 1.51605 13.75 2.66665 13.75V12.25ZM9.91665 11.6667C9.91665 11.9888 9.65548 12.25 9.33331 12.25V13.75C10.4839 13.75 11.4166 12.8173 11.4166 11.6667H9.91665ZM11.4166 3.66667C11.4166 2.51607 10.4839 1.58333 9.33331 1.58333V3.08333C9.65548 3.08333 9.91665 3.3445 9.91665 3.66667H11.4166ZM2.08331 3.66667C2.08331 3.3445 2.34448 3.08333 2.66665 3.08333V1.58333C1.51605 1.58333 0.583313 2.51607 0.583313 3.66667H2.08331ZM5.99998 7.75H7.99998V6.25H5.99998V7.75ZM5.99998 10.4167H7.99998V8.91667H5.99998V10.4167ZM5.33331 1.75H6.66665V0.25H5.33331V1.75ZM6.66665 2.91667H5.33331V4.41667H6.66665V2.91667ZM5.33331 2.91667C5.01115 2.91667 4.74998 2.6555 4.74998 2.33333H3.24998C3.24998 3.48393 4.18272 4.41667 5.33331 4.41667V2.91667ZM7.24998 2.33333C7.24998 2.6555 6.98881 2.91667 6.66665 2.91667V4.41667C7.81724 4.41667 8.74998 3.48393 8.74998 2.33333H7.24998ZM6.66665 1.75C6.98881 1.75 7.24998 2.01117 7.24998 2.33333H8.74998C8.74998 1.18274 7.81724 0.25 6.66665 0.25V1.75ZM5.33331 0.25C4.18272 0.25 3.24998 1.18274 3.24998 2.33333H4.74998C4.74998 2.01117 5.01115 1.75 5.33331 1.75V0.25ZM3.99998 7.75H4.00665V6.25H3.99998V7.75ZM3.99998 10.4167H4.00665V8.91667H3.99998V10.4167Z'
      fill={fill}
    />
  </svg>
)

export const SpreadsheetIcon = ({
  fill = Colors.pigeon800
}: HTMLAttributes<SVGElement> & {
  fill?: string
}) => (
  <svg width='52' height='37' viewBox='0 0 52 37' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M51.6875 10.4724C51.6875 10.297 51.6392 10.1345 51.5877 9.97674C51.3833 8.93709 50.849 7.98434 50.0395 7.2746L44.0027 1.99424C43.124 1.22335 41.9926 0.798477 40.8226 0.798477H5.01562C2.35372 0.798477 0.1875 2.9647 0.1875 5.6266V31.375C0.1875 34.0369 2.35372 36.2031 5.01562 36.2031H46.8594C49.5213 36.2031 51.6875 34.0369 51.6875 31.375V10.907C51.6875 10.8104 51.6634 10.7187 51.6569 10.6221C51.6618 10.569 51.6875 10.5239 51.6875 10.4708V10.4724ZM25.9375 20.9141V12.0818H35.5938V20.9141H25.9375ZM35.5938 24.1328V32.9844H25.9375V24.1328H35.5938ZM3.40625 12.0818H22.7188V20.9141H3.40625V12.0818ZM38.8125 12.0818H48.4688V20.9141H38.8125V12.0818ZM3.40625 31.375V24.1328H22.7188V32.9844H5.01562C4.12886 32.9844 3.40625 32.2634 3.40625 31.375ZM46.8594 32.9844H38.8125V24.1328H48.4688V31.375C48.4688 32.2634 47.7461 32.9844 46.8594 32.9844Z'
      fill={fill}
    />
  </svg>
)

export const EmptyBox = (props: HTMLAttributes<SVGElement>) => (
  <svg
    {...props}
    width='120'
    height='125'
    viewBox='0 0 120 125'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M104.847 45.9535C106.96 45.9535 108.672 44.2396 108.672 42.1255C108.672 40.0113 106.96 38.2975 104.847 38.2975C102.735 38.2975 101.023 40.0113 101.023 42.1255C101.023 44.2396 102.735 45.9535 104.847 45.9535Z'
      fill='#EAEEF9'
    />
    <path
      d='M3.25348 66.6546C4.64312 66.6546 5.76965 65.5271 5.76965 64.1362C5.76965 62.7453 4.64312 61.6178 3.25348 61.6178C1.86383 61.6178 0.737305 62.7453 0.737305 64.1362C0.737305 65.5271 1.86383 66.6546 3.25348 66.6546Z'
      fill='#EAEEF9'
    />
    <path
      d='M14.8199 111.931C16.2095 111.931 17.3361 110.804 17.3361 109.413C17.3361 108.022 16.2095 106.894 14.8199 106.894C13.4302 106.894 12.3037 108.022 12.3037 109.413C12.3037 110.804 13.4302 111.931 14.8199 111.931Z'
      fill='#EAEEF9'
    />
    <path
      d='M28.2705 111.931L63.5795 100.867V55.5057L28.2705 66.4844V111.931Z'
      fill='#F6F8FC'
      stroke='#CAD0DC'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M98.8881 111.931L63.5791 100.867V55.5057L98.8881 66.4844V111.931Z'
      fill='#F6F8FC'
      stroke='#CAD0DC'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M63.5795 123.08L28.2705 112.016V66.6546L63.5795 77.7185V123.08Z'
      fill='white'
      stroke='#CAD0DC'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M63.5791 123.08L98.8881 112.016V66.6546L63.5791 77.7185V123.08Z'
      fill='white'
      stroke='#CAD0DC'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M63.5791 55.5057L46.978 43.0802L11.0791 55.1653L28.2701 66.4844L63.5791 55.5057Z'
      fill='#F6F8FC'
      stroke='#CAD0DC'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M63.5791 55.5057L80.1802 43.0802L116.079 55.1653L98.8881 66.4844L63.5791 55.5057Z'
      fill='#F6F8FC'
      stroke='#CAD0DC'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M28.2701 66.6546L63.5791 77.7185L45.9667 88.9525L11.0791 77.378L28.2701 66.6546Z'
      fill='#F6F8FC'
      stroke='#CAD0DC'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M98.8881 66.6546L63.5791 77.7185L81.1915 88.9525L116.079 77.378L98.8881 66.6546Z'
      fill='#F6F8FC'
      stroke='#CAD0DC'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M73.4311 11.9569C78.3777 25.3814 79.8521 28.3642 80.336 41.5921C80.1499 44.6116 80.0344 47.895 78.6108 50.5389C76.7097 54.5833 72.0597 57.3843 67.6664 57.4297C63.1404 57.5105 58.7033 54.7394 56.7062 50.4663C55.3011 47.873 55.3458 44.3257 57.2732 41.9712C59.3685 39.713 63.0547 39.15 65.7064 40.5609C68.6233 41.9009 70.3643 44.6871 71.0092 47.6254C71.654 50.5637 71.3707 53.7507 70.5836 56.6483C68.9373 63.6958 67.5738 64.0367 63.5365 75.9685'
      stroke='#8B93A4'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeDasharray='4 4'
    />
    <path
      d='M79.4512 4.85138C79.4397 6.82536 77.6027 8.03405 75.2732 7.40376C72.8204 6.98565 71.0845 6.55472 70.9727 4.79293C71.029 2.98613 73.0003 2.27898 75.3076 1.48183C78.0742 0.382515 79.2947 2.9224 79.4512 4.85138Z'
      fill='#ECEEFF'
      stroke='#8B93A4'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M63.6016 10.8877C64.8447 12.1674 67.4654 12.5405 68.7425 10.5859C70.1428 8.41913 71.3415 6.84388 70.0537 5.39707C68.8106 4.11744 67.6009 4.97896 64.8343 6.07828C62.6166 7.20978 62.1458 9.48593 63.6016 10.8877Z'
      fill='#ECEEFF'
      stroke='#8B93A4'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M69.3375 2.72242C70.4688 2.24026 71.8239 2.59399 72.4286 3.50708C72.6862 3.79644 72.9885 4.25299 73.0781 4.58735C74.0409 6.83787 73.7382 9.06903 72.4389 9.59619C71.0164 10.3355 69.0566 9.0687 68.3065 6.94035C68.1274 6.27163 68.0378 5.93727 67.9035 5.43573C67.7581 4.22047 68.2062 3.20458 69.3375 2.72242C69.5055 2.67742 69.3375 2.72242 69.3375 2.72242Z'
      fill='#F1F3F9'
    />
    <path
      d='M69.3375 2.72242C70.4688 2.24026 71.8239 2.59399 72.4286 3.50708C72.6862 3.79644 72.9885 4.25299 73.0781 4.58735C74.0409 6.83787 73.7382 9.06903 72.4389 9.59619C71.0164 10.3355 69.0566 9.0687 68.3065 6.94035C68.1274 6.27163 68.0378 5.93727 67.9035 5.43573C67.7581 4.22047 68.2062 3.20458 69.3375 2.72242ZM69.3375 2.72242C69.3375 2.72242 69.5055 2.67742 69.3375 2.72242V2.72242Z'
      fill='#ECEEFF'
      stroke='#8B93A4'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M17.3364 38.9504H15.1463V36.7603H13.2691V38.9504H11.0791V40.8901H13.2691V43.0802H15.1463V40.8901H17.3364V38.9504Z'
      fill='#AAB2C5'
    />
    <path
      d='M22.1468 93.8975H19.9568V91.7075H18.0796V93.8975H15.8896V95.8373H18.0796V98.0273H19.9568V95.8373H22.1468V93.8975Z'
      fill='#AAB2C5'
    />
    <path
      d='M117.885 94.0215L115.205 92.6687L116.558 89.9891L114.261 88.8295L112.908 91.5091L110.229 90.1562L109.031 92.5295L111.71 93.8824L110.357 96.5619L112.654 97.7215L114.007 95.042L116.687 96.3949L117.885 94.0215Z'
      fill='#AAB2C5'
    />
  </svg>
)

export const GiftIcon = ({ stroke = Colors.brandPrimary, ...props }) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9 5.66667V16.5M9 5.66667C9 5.66667 9 4.42269 9 4C9 3.07953 9.74619 2.33333 10.6667 2.33333C11.5871 2.33333 12.3333 3.07953 12.3333 4C12.3333 4.92047 11.5871 5.66667 10.6667 5.66667C10.1689 5.66667 9 5.66667 9 5.66667ZM9 5.66667C9 5.66667 9 4.05243 9 3.58333C9 2.43274 8.06726 1.5 6.91667 1.5C5.76607 1.5 4.83333 2.43274 4.83333 3.58333C4.83333 4.73393 5.76607 5.66667 6.91667 5.66667C7.59817 5.66667 9 5.66667 9 5.66667ZM3.16667 9H14.8333M3.16667 9C2.24619 9 1.5 8.25381 1.5 7.33333C1.5 6.41286 2.24619 5.66667 3.16667 5.66667H14.8333C15.7538 5.66667 16.5 6.41286 16.5 7.33333C16.5 8.25381 15.7538 9 14.8333 9M3.16667 9L3.16667 14.8333C3.16667 15.7538 3.91286 16.5 4.83333 16.5H13.1667C14.0871 16.5 14.8333 15.7538 14.8333 14.8333V9'
      stroke={stroke}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const KeyIcon = ({ stroke = Colors.pigeon600, ...props }) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.5 4.83333C12.4205 4.83333 13.1667 5.57953 13.1667 6.5M16.5 6.5C16.5 9.26142 14.2614 11.5 11.5 11.5C10.9949 11.5 10.5072 11.4251 10.0476 11.2858L8.16667 13.1667H6.5V14.8333H4.83333V16.5H2.33333C1.8731 16.5 1.5 16.1269 1.5 15.6667V13.5118C1.5 13.2908 1.5878 13.0789 1.74408 12.9226L6.71423 7.95244C6.57491 7.49279 6.5 7.00514 6.5 6.5C6.5 3.73858 8.73858 1.5 11.5 1.5C14.2614 1.5 16.5 3.73858 16.5 6.5Z'
      stroke={stroke}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
